export default __webpack_public_path__ + "static/media/3-responsive.ef78942a.jpeg";